(function () {
  'use strict';

  if (window.innerWidth > 768) return;

  var drawer = document.getElementById('mnav-drawer');
  if (!drawer) return;

  var toggleBtn = document.querySelector('[data-mobile-nav-toggle]');
  var details   = toggleBtn ? toggleBtn.closest('details') : null;

  // ── Measure actual header height and apply as CSS variable ───────────────
  // This keeps the drawer positioned exactly below the header regardless of
  // announcement bars, sticky offsets, etc.
  var headerSection = document.getElementById('shopify-section-header');
  if (headerSection) {
    document.documentElement.style.setProperty(
      '--mnav-header-h',
      headerSection.offsetHeight + 'px'
    );
  }

  // ── Listen to the native <details> toggle event ──────────────────────────
  // Lets the hamburger ↔ X icon swap (driven by base.css `details[open]`)
  // work without conflict, while we react to open/close for the new drawer.
  if (details) {
    details.addEventListener('toggle', function () {
      if (window.innerWidth > 768) return;
      details.open ? openDrawer() : closeDrawer(true);
    });
  }

  // ── ESC key closes drawer ─────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer(false);
    }
  });

  // ── Open / close helpers ──────────────────────────────────────────────────
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.focus();
  }

  function closeDrawer(skipDetails) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // When closed via ESC (not via the summary click), manually close the
    // <details> so the X → hamburger icon swap happens correctly.
    if (!skipDetails && details) {
      details.open = false;
    }
  }

  // ── Accordion: category sections ─────────────────────────────────────────
  drawer.querySelectorAll('.mnav-cat-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body   = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Collapse all open sections
      drawer.querySelectorAll('.mnav-cat-header').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var otherBody = other.nextElementSibling;
        if (otherBody) otherBody.classList.remove('is-open');
      });

      // Expand the clicked section (unless it was already open)
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        if (body) body.classList.add('is-open');
      }
    });
  });

})();
